import { Local } from '@/utils/storage'
import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import { commonRoutes } from "./route"
import { adRoutes } from "./adRoute"
import { ElMessage } from 'element-plus'


export const routes: Array<RouteRecordRaw> = [...commonRoutes,...adRoutes]

const venuePath = ['/cashier/venue','/cashier/shop','/venue/appo','/venue/scheduling','/card/list','/shop/list']

const router = createRouter({
  history: createWebHashHistory(),
  scrollBehavior: () => ({
    top: 0
  }),
  routes
})

router.beforeEach((to, from, next) => {
	if(to.meta && to.meta.mode === 'ad'){
		next();
	}
	
	let mec = Local.get("current_mechanism")
    const token = Local.get('token');
	let venue = Local.get("current_venue")

	if (to.path === '/login' && !token) {
		next();
	} else {
		if (!token) {
			next('/login');
		}else if(!mec) {
			next('/login');
		} else if (token && to.path === '/login') {
			next('/home');
		}else if(venuePath.includes(to.path) && !venue) {
			ElMessage.error('还没有创建场馆，功能不可用')
			ElMessage.info('请前往-门店管理-场地管理-创建场馆')
			return
		} else {
			next();
		}
	}
})

router.afterEach((to) => {
	let title = '汇合联营社'
	if(to.meta && to.meta.title){
		title =  to.meta.title as string
	}
	document.title = title
	// to and from are both route objects.
})

export default router
